import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
})
export class MainComponent implements OnInit, OnDestroy {
	showPagine = false;
	burgerMenu = false;
	constructor() {}

	ngOnInit() {}

	ngOnDestroy() {}
}
